export const HOST = "https://be.cicinhakhanh.com/api";
export const HOSTWEB = "https://be.cicinhakhanh.com";

// export const HOST = "http://localhost:8000/api";
// export const HOSTWEB = "http://localhost:8000";

export const AUTH = "/auth";

export const REGISTER = "/register";
export const LOGIN = "/login";
export const INFO_USER = "/me";
export const USER = "/users";

export const SOUL_PLANS = "/soul_plans";
export const MATRIX = "/matrix";
export const SOUL_PLAN_PERSONAL_URL = "/soul-plan";
export const SOUL_PLAN_GROUP_URL = "/soul-plan-group";
export const MATRIX_OF_DESTINY_URL = "/Matrix";

export const VIEW = "/view";
export const EXPORT = "/export";

export const UPLOAD_URL = "/upload";
export const FILE = "/file";
export const PROXY_IMAGE = "/proxy-image";

export const AVATAR_FOLDER = "avatar";
